import moment from "moment";

class TextUtil {
    getCreatedTimeText(createdTime){
        var createdTimeDate = moment(createdTime);
        return createdTimeDate.format('DD.MM.YYYY HH:mm:ss');
    }

    /**
     * Text made safe to splice into HTML. ConfirmDialogue renders its `message` with v-html, so a name
     * concatenated into it is parsed as markup — and some names are typed by strangers: a table
     * booking's guest name comes from the public booking form. Callers keep their own <br/>/<strong>
     * and escape only the data.
     */
    escapeHtml(value){
        const entities = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
        return String(value == null ? '' : value).replace(/[&<>"']/g, c => entities[c]);
    }
}

export default new TextUtil();